export default __webpack_public_path__ + "static/media/Amazon.bd664c74.svg";